const WalletIcon = ({ ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      data-testid="connect-wallet-icon-id"
      {...props}
    >
      <rect width="16" height="16" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0_609_2564" transform="scale(0.0104167)" />
        </pattern>
        <image
          id="image0_609_2564"
          width="96"
          height="96"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAAEHklEQVR4nO2dQYhVVRjHf/MsW2izGNrEWKgpBSNZLaK2phs1gyxI2hRquCjEWog7ESoCUaRAkIkgFFzpQlMUS2yRsypFU1yYoZYuRMrRSCtHPuZ7dDnvvnk5991zpjn/Hzwe57773nfu93/n3O+e891zEUIIIYQQQgghhBDZ0DMyMhIe6zxgFbAQmAlM09/hvrgF/AwcAQaB02N9uSjAVGArsAZoTKhD+v/yD7Ad+AC4U3YUTQHM+QeBBbl7rCa+BhaXidD8p2+V82vlJWBzmQFrAdbnnwCmTJ7jnZBYdzQf+LFYOWsBq+X8KJiPV4aGGh7tiDgsCq1YFzQMTJcAUTBf9xYNmQAtFwKiVnqKP654PzESIDESIDESIDESIDESIDESIDESIDESIDESIC6XQmsSIB7m/HdCaw9M4gOuig2c7QeO+nyJzfP+BvzVTSMSoJUrwCbgS+CPuo1JgH+5DXwIbPHMhihIgFGuAcuBb2Mb1kl4NG/nuTbOfwx41zNGzgI3gZFxvuy7Q/57U5sGcp+QuQo8XxIe9gMbgbdrmi+3k/pS4JecBfjTU3GOB9uXATuBh2u2/wPwQs5d0Eclzn8P2BvB+cazlpGSawuwUHNuEO0sc+fH/FMO5doCNgXO7/duJ7Y/BnJsARaNPOrvTQbLkqZikGML2Bc430LNt1JVJkcBjgblV/5DqGlh6mueVGWvV4Fz3ahMjlfCJ4Ly4g77m/OfAa4XttnJ+hhwEphRpTI5toALQfmJDvuvC5zfxLa9X7UyOZ6EHwpulLjRIe7v9aHpdp/9XqUyGguqRk/VH8hRgN6gfKXD/mOl71dO7c9RgNlB+XyH/T8G+kq29/lnlchRgPlB+asO+z/p0c7rhTB0uQ8tz61amRxPwruBFYXyDI+MkoTkObaApcEdQZeBL1JVJkcBzPlvBNs2jhFq1slwrmHoeuDBQvlX4E3gbuR6nM5VgDklV7E2SLc2sgg7c56SvO1Tkt8F2+0csavkeqHbfA+8mPOVsA1J7AEeD7ZbNtxTwA7g75psm/NftiGR3LMi8LSUJcDFks/6farSWsUsnzsY7z3VNgdxymfeBpvjURJglGs+3n8stmENxo3yCHAI2FBMmoqBWkArPwGf+Im49hxRCdAe67MPAN/4LNoFT08vXflqvEiAeFz2GzQOFi1KgLhcCsNeCRAfrZYykZAAiZEAiZEAiZEAiZEAiZEAiZEAiZEAiWkkygbIlRvhcTfKllARtdEy62YCHJa/o3EoNGSDcQOe+6gV1OvFlq9/GjhTtNLw9ey3T8IDnmh8Fjqf4BEmB/xJD6L7HPF70VoWe2qGoXd8h0+9qYjuYHlF29o5nzaPsRrwm5YX+WOs9GyB++OmL29mwc3nZd2OEEIIIYQQQgghhMgQ4B754wKcY8hoBwAAAABJRU5ErkJggg=="
        />
      </defs>
    </svg>
  )
}

export default WalletIcon
